import { LoadingButton } from '@mui/lab'
import { Button, Checkbox, Dialog, DialogActions, DialogContent, DialogTitle, Grid, MenuItem, TextField } from '@mui/material'
import React, { useEffect, useState } from 'react'
import { useEditController, useNotify, useTranslate } from 'react-admin'
import { EditInputsWrap } from 'src/components/uiElements/CRUD/EditInputsWrap'
import CloseIcon from '@mui/icons-material/Close';
import DoneIcon from '@mui/icons-material/Done';
import { userServices } from 'src/services/auth/user/user.service'
import { minHeight } from '@mui/system'

export const ModalEditConfigVars = ({open, setOpen, config, clientId, setList, setLoading}) => {
    const translate = useTranslate()
    const notify = useNotify()
    const { record } = useEditController()
    const [configVars, setConfigVars] = useState([])
    const [addVar, setAddVar] = useState(false)
    const [isBool, setIsBool] = useState(false)
    const [updateLoading, setUpdateLoading] = useState(false)
    const [newVar, setNewVar] = useState({
       title:'',
       value:'', 
    })

    const changeNewVar = (field, value) =>{
        setNewVar(prev=>({...prev, [field]:value}))
    }

    const onAddVar = () =>{
        if(newVar.title && newVar.value){
            const auxVars = [...configVars]
            auxVars.push([newVar.title, newVar.value])
            setConfigVars(auxVars)
            setAddVar(false)
            setNewVar({
                title:'',
                value:'',
            })
        }
    } 

    useEffect(()=>{
        let initialConfig = config ? {...config} : {}
        let mandatoryFields = ['nrf_book', 'show_supplier']
        for(let field of mandatoryFields){
            if(!(Object.keys(initialConfig).includes(field))){
                initialConfig[field] = false
            } else {
                if(typeof initialConfig[field] != 'boolean'){
                    initialConfig[field] = false
                }
            }
        }
        
        setConfigVars(Object.entries(initialConfig))
    },[config])

    const updateConfig = async () =>{
        if(configVars){
            const config = Object.fromEntries(configVars)
            setUpdateLoading(true)
            await userServices.updateUserConfig(clientId,config).then(()=>{
                onClose()
            }).catch(()=>{
                notify('ra.notification.edit_variables_error',{type:'error'})
            }).finally(()=>{
                setUpdateLoading(false)
            })
        }
        
    }

    const changeField = (field, value) =>{
        let auxVars = [...configVars]
        for(let variable of auxVars){
            if(variable[0] === field){
                variable[1] = value
            }
        }
        setConfigVars(auxVars)
    }

    const onClose = async () =>{
        setOpen(false)
        setLoading(true)
        notify('ra.notification.edit_variables_success',{type:'success'})
        const list = await userServices.userByClientApp(record?.id)
        setList(list)
        setLoading(false)
    }

  return (
    <Dialog fullWidth open={open} onClose={()=>setOpen(false)}>
        <DialogTitle>
            {translate('ra.field.config')}
        </DialogTitle>
        <DialogContent>
            <Grid container>
                {configVars?.map((field, idx)=>(
                    <EditInputsWrap key={idx} label={translate(`ra.field.${field[0]}`) === `ra.field.${field[0]}`? field[0] : translate(`ra.field.${field[0]}`)} lg={6} md={6}>
                        {
                        typeof field[1] === 'boolean' ?
                            <Checkbox 
                                checked={field[1]}
                                onChange={(e)=>changeField(field[0], e.target.checked)}
                            />
                            :
                            <TextField
                                value={field[1]}
                                onChange={(e)=>changeField(field[0], e.target.value)}
                                size='small'
                            />
                        }
                    </EditInputsWrap>
                ))}
                
            </Grid>
            <Button variant='contained' onClick={()=>setAddVar(true)}>
                {`${translate('ra.action.add')} variable`}
            </Button>
            {addVar && 
            <div style={{display:'flex', flexDirection:'column'}}>
                <Grid 
                    container 
                    style={{
                        marginTop:'15px', 
                        borderColor:'grey', 
                        borderWidth:'1px', 
                        borderStyle:'solid',
                        padding:'10px',
                        borderRadius:'10px'
                    }}
                >
                    <EditInputsWrap label={translate('ra.field.title')} lg={5} md={5} style={{minHeight:'80px'}}>
                        <TextField
                            onChange={e=>changeNewVar('title', e.target.value)}
                            size='small'
                            required
                        />
                    </EditInputsWrap>
                    <EditInputsWrap label={translate('ra.field.value')} lg={5} md={5} style={{minHeight:'80px'}}>
                        {isBool ? 
                            <TextField
                                size='small'
                                select
                                fullWidth
                                required={isBool}
                                onChange={e=>changeNewVar('value', e.target.value)}
                            >
                                <MenuItem value={true}>{translate('ra.boolean.true')}</MenuItem>
                                <MenuItem value={false}>{translate('ra.boolean.false')}</MenuItem>
                            </TextField>
                        :
                            <TextField
                                size='small'
                                required={!isBool}
                                onChange={e=>changeNewVar('value', e.target.value)}
                            />
                        }
                    </EditInputsWrap>
                    <EditInputsWrap  style={{minHeight:'80px'}} lg={2} md={2} label={`${translate('ra.message.yes')}/${translate('ra.message.no')}`}>
                        <Checkbox
                            checked={isBool}
                            onChange={()=>{
                                setIsBool(prev=>!prev)
                                changeNewVar('value','')
                            }}
                        />
                    </EditInputsWrap>

                </Grid>
                <div style={{alignSelf:'flex-end', marginTop:'15px'}}>
                    <CloseIcon style={{cursor:'pointer', marginLeft:'15px'}} color='error' onClick={()=>setAddVar(false)}/>
                    <DoneIcon style={{cursor:'pointer'}} onClick={onAddVar}/>
                </div>
            </div>
            }
        </DialogContent>
        <DialogActions>
            <Button onClick={()=>setOpen(false)} variant='outlined'>
                {translate('ra.action.cancel')}
            </Button>
            <LoadingButton 
                variant='contained'
                onClick={updateConfig}
                loading={updateLoading}
            >
                {translate('ra.action.to_confirm')}
            </LoadingButton>
        </DialogActions>
    </Dialog>
  )
}